import { InvestmentsExperimentFlag } from 'investments/common/enums'

export const MARKET_INVESTMENTS_FLOW_FLAG =
  InvestmentsExperimentFlag.MarketInvestmentsFlow

export const investmentsFlags = [MARKET_INVESTMENTS_FLOW_FLAG] as const
